import React, { useState } from 'react';
import { Card, Button, Row, Col, Toast } from 'react-bootstrap';
import { useHistory, useRouteMatch } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { addFavorite } from '../store/action';
import { Loading } from './Loading'

function MyCard(props) {
    const [showToast, setShowToast] = useState(false);
    const [FavButton, setFavButton] = useState(true);
    const isFavoritesUrl = useRouteMatch("/favorites")
    const history = useHistory()
    const dispatch = useDispatch()

    function goToDetail(id){
        history.push(`/detail/${id}`)
    }

    function handleAddFavorite(data){
        dispatch(addFavorite(data))
        setShowToast(true)
        setFavButton(false)
    }

    if(showToast) {
        return (
            <div style={{ position: 'absolute', bottom: 0, left: 0, }}>
            <Toast onClose={() => setShowToast(false)} show={showToast} delay={1000} autohide className="h-100">
                <Toast.Header>
                    <strong className="mr-auto">Add Favorite</strong>
                </Toast.Header>
                <Toast.Body>Woohoo, added to favorites!</Toast.Body>
                <Loading className="align-items-end"/>
            </Toast>
            </div>

        )           
    }

    function showFavButton() {
        if(!isFavoritesUrl && FavButton){
            return <Col><Button variant="primary" size="sm" onClick={() => handleAddFavorite(props.movie)}>Add To Favorites</Button></Col>
        }
    }

    return (
        <>
            <Card style={{ width: '20rem', margin: '1rem'}} border="warning">
            <Card.Img variant="top" src={`https://image.tmdb.org/t/p/w500${props.movie.poster_path}`} />
            <Card.Body>
                <Card.Title>{ props.movie.title }</Card.Title>
                <Card.Text>
                    <Row xs={1} md={2}>
                        <Col>Release: { props.movie.release_date}</Col>
                        <Col>Popularity: { props.movie.popularity}</Col>
                        <Col>Vote: { props.movie.vote_count}</Col>
                        <Col>Avg Vote: { props.movie.vote_average}</Col>
                    </Row>
                </Card.Text>
                <Row className="text-center">
                    {
                        showFavButton()
                    }
                    <Col><Button variant="warning" size="sm" onClick={() => goToDetail(props.movie.id)}>More Info</Button></Col>
                </Row>
            </Card.Body>
            </Card>
        </>
    )
}

export default MyCard